<!--
    Backdrop do modo overlay (mobile/tablet, ≤1024px). Fica atrás da sidebar,
    cobre o conteúdo e, ao ser tocado, solicita o fechamento via `closeRequested`.
    Fora desse breakpoint é `display: none` (ver SCSS).
-->
<div
    [ngClass]="{
        'ai-sidebar-backdrop': true,
        'ai-sidebar-backdrop-visible': visible(),
    }"
    (click)="onBackdropClick()"
></div>

<aside
    [ngClass]="{
        'ai-sidebar-container': true,
        'ai-sidebar-container-floating': floating(),
        'ai-sidebar-container-visible': visible(),
    }"
>
    <ng-content select="ai-sidebar-header" />
    <ng-content select="ai-menu" />
    <ng-content select="ai-sidebar-content" />
</aside>
